(() => {
  const fill = (name, value) => {
    document.querySelectorAll('[data-hrd-' + name + '-input]').forEach(input => {
      if (input.tagName === 'SELECT' && ![...input.options].some(option => option.value === value)) return;
      input.value = value;
      if (name === 'product') input.closest('.hrdi-product-interest').hidden = !value;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  };
  const params = new URLSearchParams(window.location.search);
  for (const name of ['generation','service','product','url','variant']) if (params.get('install_' + name)) fill(name,params.get('install_' + name).slice(0,name === 'url' ? 500 : 250));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-hrd-generation],[data-hrd-service],[data-hrd-action]');
    if (!link) return;
    if (link.hasAttribute('data-hrd-product-link')) {
      const chosen = document.querySelector('[data-product-variant]');
      const option = chosen && chosen.selectedOptions[0];
      if (option && option.textContent.trim()) {
        const target = new URL(link.href, window.location.origin);
        target.searchParams.set('install_variant', option.textContent.trim().slice(0,250));
        link.href = target.href;
      }
    }
    for (const name of ['generation','service']) {
      const value = link.getAttribute('data-hrd-' + name);
      if (!value) continue;
      const form = document.querySelector('.hrdi-quote-form');
      const destination = new URL(link.href, window.location.origin);
      const isSamePageQuote = destination.pathname === window.location.pathname && destination.hash === '#install-quote';
      if (form && isSamePageQuote) {
        event.preventDefault(); fill(name,value);
        form.closest('section').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        const field = form.querySelector('[name="contact[name]"]');
        field.focus({preventScroll:true});
      } else {
        const url = new URL(link.href,window.location.origin);url.searchParams.set('install_' + name,value);link.href=url.href;
      }
    }
    if (link.dataset.hrdAction) document.dispatchEvent(new CustomEvent('hrd:action',{detail:{action:link.dataset.hrdAction}}));
  });
  if(document.querySelector('[data-hrd-lead-status="success"]')) document.dispatchEvent(new CustomEvent('hrd:quote-sent'));
})();
